import { vehicleStatusMessages } from "@slfinrtl/ui-bff-routes"
import type { VehicleStatus } from "@slfinrtl/ui-bff-routes"
import { useIntl } from "react-intl"
import { Badge } from "../badge/Badge"
import { getStatusBadgeColor } from "./getStatusBadgeColor"

interface StatusBadgeProps {
	autoWidth?: boolean
	status: VehicleStatus
}

export const StatusBadge = ({ status, ...rest }: StatusBadgeProps) => {
	const { formatMessage } = useIntl()
	const statusMessage = vehicleStatusMessages[status]
	return <Badge label={formatMessage(statusMessage)} color={getStatusBadgeColor(status)} {...rest} />
}
